module.exports = __webpack_public_path__ + "img/medMission_041022_D.e7865880.jpg";